import { NoSymbolIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../components/auth/AuthProvider';

export interface NotFoundProps {
  showNavbar?: boolean;
}

function NotFound({
  showNavbar = true,
}: NotFoundProps) {
  const { t } = useTranslation();

  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated && showNavbar &&
        <div className="p-6 max-w-sm mx-auto bg-white rounded-xl shadow-md flex items-center space-x-4">
          <NoSymbolIcon className="text-red-700 w-12 h-12" />
          <p className="prose"> {t('notfound.message')} </p>
        </div>
      }
    </>
  );
}

export default NotFound;